<template>
  <qx-card title="列表">
    <section slot="titleRight">
      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <section
                  v-if="scope.column.property === 'tenantName'"
                  @click="toTenantDetail(scope.row)"
                >
                  <span class="primary cur">
                    {{ scope.row[scope.column.property] }}
                  </span>
                </section>
                <section v-if="scope.column.property !== 'tenantName'">
                  {{ scope.row[scope.column.property] }}
                </section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
            prop="control"
            label="操作"
            fixed="right"
            width="160"
          >
            <template slot-scope="scope">
              <TableBtn
                :tableData="scope.row"
                :isCenter="true"
                :btnList="[
                  {
                    showCondition: true,
                    name: '查看',
                    event: () => toEdit(scope.row, 4),
                  },
                  {
                    permpisions: '1400207',
                    showCondition:
                      scope.row.verState != 9 &&
                      scope.row.applyVehicleClass != 1 &&
                      (scope.row.newApplyId == '' ||
                        scope.row.newApplyId == null) &&
                      scope.row.state == 2,
                    name: '再次邀请',
                    event: () => toEdit(scope.row, 1),
                  },
                  {
                    permpisions: '1400206',
                    showCondition:
                      scope.row.verState != 9 &&
                      scope.row.applyVehicleClass == 1 &&
                      (scope.row.newApplyId == '' ||
                        scope.row.newApplyId == null) &&
                      scope.row.state == 2,
                    name: '再次申请',
                    event: () => toEdit(scope.row, 2),
                  },
                  {
                    permpisions: '1400208',
                    showCondition:
                      scope.row.verState != 9 &&
                      (scope.row.applyVehicleClass == 1 ||
                        scope.row.applyVehicleClass == 4) &&
                      (scope.row.newApplyId == '' ||
                        scope.row.newApplyId == null) &&
                      scope.row.state == 2,
                    name: '申请平台仲裁',
                    event: () => toEdit(scope.row, 3),
                  },
                ]"
              />
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import TableBtn from 'components/tableBtn/tableBtn';
import TableSetting from 'components/tableSetting/tableSetting';
import {
  doQueryVehicleApplyRecordAll,
} from 'api/car';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    TableBtn,
    TableSetting,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { prop: 'plateNumber', label: '车牌号码', fixed: true },
          { prop: 'applyVehicleClassName', label: '申请类型' },
          { prop: 'tenantName', label: '归属车队' },
          { prop: 'linkPhone', label: '车队手机' },
          { prop: 'beApplyDriverMobile', label: '司机手机' },
          { prop: 'beApplyDriverName', label: '司机名称' },
          { prop: 'createDate', label: '申请时间' },
          { prop: 'stateName', label: '审核状态' },
          { prop: 'auditDate', label: '处理时间' },
          { prop: 'auditRemark', label: '处理意见' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: doQueryVehicleApplyRecordAll,
    toTenantDetail (item) {
      this.jump({
        label: '车队详情',
        url: `/manage/other/fleet?id=${item.beApplyTenantId}`,
        full: true,
      });
    },
    toEdit (item, index) {
      let label = '';
      let type = '';
      switch (index) {
        case 1:
          label = '再次邀请';
          type = 'invite';
          break;
        case 2:
          label = '申请转移';
          type = 'apply';
          break;
        case 3:
          label = '申请平台仲裁';
          type = 'arbitration';
          break;
        default:
          label = `查看邀请详情-${item.plateNumber}`;
          type = 'detail';
          break;
      }
      this.jump({
        label,
        url: `/manage/car/archives/invite/detail?id=${item.id}&type=${type}`,
        full: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
